import PureGameElement    from '../../tools/PureGameElement';
import { gameWindowSize } from '../../constants/appConstants';

class Rail extends PureGameElement {
    constructor ( scene, index ) {
        super( scene );
        this._index = index;
    }

    get width () {
        return Math.round( gameWindowSize.width / this.scene.rails.length );
    }

    get leftPosition () {
        return this.width * this._index;
    }

    get leftCenterPosition () {
        return this.leftPosition + Math.round( this.width / 2 );
    }

    get index () {
        return this._index;
    }


}

export default Rail;
